import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.7784 17.1481L18.7788 17.1466L28.0156 22.6793L33.5196 20.3631C34.638 19.8796 35.844 19.6316 37.0625 19.6328C37.2655 19.6328 37.4662 19.642 37.6658 19.6553C37.0041 17.075 35.6071 14.7425 33.6448 12.9411C31.6824 11.1398 29.239 9.94718 26.6116 9.50827C23.9842 9.06935 21.2859 9.40302 18.8445 10.4687C16.4032 11.5344 14.3239 13.2862 12.8595 15.5114C12.9065 15.5108 12.9528 15.5078 13 15.5078C15.0414 15.505 17.0429 16.0732 18.7784 17.1481Z",
      fill: "#0364B8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.7788 17.1466L18.7784 17.1481C17.0429 16.0732 15.0414 15.5051 13 15.5078C12.9528 15.5078 12.9064 15.5108 12.8594 15.5114C10.8614 15.5361 8.90792 16.1048 7.20885 17.1564C5.50979 18.208 4.12939 19.7027 3.21601 21.4799C2.30263 23.2571 1.89078 25.2495 2.02474 27.2432C2.1587 29.2369 2.83339 31.1564 3.97631 32.7954L12.1218 29.3676L15.7428 27.8439L23.8051 24.4511L28.0155 22.6793L18.7788 17.1466Z",
      fill: "#0078D4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37.6658 19.6554C37.4662 19.642 37.2655 19.6328 37.0625 19.6328C35.844 19.6316 34.6383 19.8805 33.5198 20.364L28.0156 22.6793L29.6116 23.6353L34.8434 26.7691L37.126 28.1363L44.931 32.8114C45.6402 31.4949 46.0077 30.0214 45.9999 28.5261C45.9921 27.0307 45.6092 25.5611 44.8863 24.2521C44.1634 22.943 43.1236 21.8362 41.8621 21.0332C40.6006 20.2301 39.1578 19.7563 37.6658 19.6554Z",
      fill: "#1490DF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37.126 28.1362L34.8434 26.769L29.6116 23.6352L28.0156 22.6792L23.8051 24.451L15.7428 27.8438L12.1218 29.3675L3.97633 32.7953C4.98856 34.2506 6.33796 35.4393 7.90932 36.2599C9.48067 37.0805 11.2273 37.5087 13 37.5077H37.0625C38.6759 37.5082 40.2593 37.0719 41.6446 36.245C43.03 35.4181 44.1656 34.2316 44.931 32.8113L37.126 28.1362Z",
      fill: "#28A8EA"
    }, null, -1)
  ])))
}
export default { render: render }